// @flow
import { styles as containerStyles } from './container';

export const styles = {
    fullWidth: {
        width: '100%',
    },
    threeQuartersWidth: {
        width: '75%',
    },
    twoThirdsWidth: {
        width: '66%',
    },
    halfWidth: {
        width: '50%',
    },
    thirdWidth: {
        width: '33%',
    },
    quarterWidth: {
        width: '25%',
    },
    ...containerStyles,
};

export default class UIStyleWidth {
    static full() {
        return styles.fullWidth;
    }

    static threeQuarters() {
        return styles.threeQuartersWidth;
    }

    static twothirds() {
        return styles.twoThirdsWidth;
    }

    static half() {
        return styles.halfWidth;
    }

    static third() {
        return styles.thirdWidth;
    }

    static quarter() {
        return styles.quarterWidth;
    }

    // Containers
    static fullCenterContainer() {
        return styles.fullWidthCenterContainer;
    }

    static fullPaddingContainer() {
        return styles.fullWidthPaddingContainer;
    }

    static halfContainer() {
        return styles.halfWidthContainer;
    }

    static thirdContainer() {
        return styles.thirdWidthContainer;
    }

    static twoThirdsContainer() {
        return styles.twoThirdsWidthContainer;
    }
}
